import { useEffect } from 'react'

import { useValidationsByFeatureStore } from '../../stores'

import { FeatureType } from '@/domain/settings/settingTypes'

interface ResetValidationByFeatureOnRouteEntryProps {
  feature?: FeatureType
}

export const ResetValidationByFeatureOnRouteEntry: React.FC<
  ResetValidationByFeatureOnRouteEntryProps
> = ({ feature }) => {
  const setFeature = useValidationsByFeatureStore((s) => s.setFeature)

  useEffect(() => {
    if (feature) setFeature(feature)
  }, [feature, setFeature])

  return null
}
